import { makeStyles } from '@alpha/ui-lib/theme';

const useStyles = makeStyles(({ palette }) => ({
  arrow: {
    color: palette.grey[900],
  },
  tooltip: {
    backgroundColor: palette.grey[900],
    padding: '13px 22px',
    fontSize: '11px',
  },
}), { name: 'Tooltip' });

export default useStyles;
